import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../Hooks/useAuth';
import { Spin } from 'antd';

const PrivateRoute = () => {
    const { user, isLoading } = useAuth();
    const location = useLocation();

    // Show loading state while checking authentication
    if (isLoading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <Spin size="large" tip="Vérification de votre session..." />
            </div>
        );
    }

    // If not authenticated, redirect to login
    if (!user) {
        return <Navigate to="/auth/login" replace state={{ from: location }} />;
    }

    // If authenticated, allow access to child routes
    return <Outlet />;
};

export default PrivateRoute;
